import React, { useState, Fragment } from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { Dialog, Transition } from '@headlessui/react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import LoadingButtonFixedWidth from '../../components/LoadingButtonFixedWidth';

export default function MorePartsModal({ openEditModal, setOpenEditModal, handleSubmit, isLoading, setNewPartInput }) {
    const [isShowing, setIsShowing] = useState(false);
    return (
        <Transition.Root show={openEditModal} as={Fragment}>
            <Dialog as='div' className='relative z-10' onClose={setOpenEditModal}>
                <Transition.Child
                    as={Fragment}
                    enter='ease-out duration-300'
                    enterFrom='opacity-0'
                    enterTo='opacity-100'
                    leave='ease-in duration-200'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'
                >
                    <div className='fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity' />
                </Transition.Child>

                <div className='overflow-y-auto fixed inset-0 z-10'>
                    <div className='flex justify-center items-end p-4 min-h-full text-center sm:items-center sm:p-0'>
                        <Transition.Child
                            as={Fragment}
                            enter='ease-out duration-300'
                            enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                            enterTo='opacity-100 translate-y-0 sm:scale-100'
                            leave='ease-in duration-200'
                            leaveFrom='opacity-100 translate-y-0 sm:scale-100'
                            leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
                        >
                            <Dialog.Panel className='overflow-hidden relative max-w-2xl transition-all transform sm:w-full'>
                                <div>
                                    <div className='mt-3'>
                                        <div className='px-2 pb-5'>
                                            <form>
                                                <div className='overflow-hidden'>
                                                    <div className='pb-12 mx-auto mt-6 mb-3 bg-gray-50 border-2 shadow-xl md:w-5/6 border-blue-primary'>
                                                        <div className='relative'>
                                                            <button
                                                                className='flex absolute top-1 right-1 justify-center items-center mt-1 mr-2 w-6 h-6 text-red-500 bg-white rounded-full cursor-pointer hover:bg-gray-400'
                                                                onClick={() => {
                                                                    setOpenEditModal(false);
                                                                }}
                                                            >
                                                                <XMarkIcon className='w-5 h-5' />
                                                            </button>
                                                        </div>
                                                        <h2 className='px-12 py-2 mb-6 text-3xl font-semibold text-center text-white bg-blue-primary'>
                                                            Bulk Parts Search
                                                        </h2>
                                                        <div className='relative'>
                                                            <p className='pl-4 text-center text-gray-600'>
                                                                Enter a list of part numbers on new lines.{' '}
                                                                <QuestionMarkCircleIcon
                                                                    onMouseEnter={() => setIsShowing(true)}
                                                                    onMouseLeave={() => setIsShowing(false)}
                                                                    className='inline-block w-5 h-5'
                                                                />
                                                            </p>
                                                            {isShowing && (
                                                                <Transition
                                                                    appear={true}
                                                                    show={isShowing}
                                                                    enter='transition-opacity duration-200'
                                                                    enterFrom='opacity-0'
                                                                    enterTo='opacity-100'
                                                                    leave='transition-opacity duration-150'
                                                                    leaveFrom='opacity-100'
                                                                    leaveTo='opacity-0'
                                                                >
                                                                    <div className='absolute right-0 p-4 w-36 text-lg md:-top-30 md:right-10 bg-blue-primary'>
                                                                        <p className='pl-4 text-white'>
                                                                            Example:
                                                                            <br />
                                                                            12345
                                                                            <br />
                                                                            GQ756-2
                                                                            <br />
                                                                            G700-2
                                                                        </p>
                                                                    </div>
                                                                </Transition>
                                                            )}
                                                        </div>
                                                        <div className='px-12 py-4'>
                                                            <textarea
                                                                onChange={(e) => {
                                                                    setNewPartInput(e.target.value);
                                                                }}
                                                                style={{ resize: 'both' }}
                                                                className='px-3 py-2 w-full text-base placeholder-gray-400 text-gray-700 rounded-lg border resize-y focus:shadow-outline focus:outline-gray-200'
                                                                placeholder='Enter part numbers here'
                                                                rows={7}
                                                            ></textarea>
                                                        </div>
                                                        {!isLoading ? (
                                                            <button
                                                                className='px-4 py-2 mx-auto w-1/2 font-bold text-white rounded cursor-pointer bg-blue-primary hover:bg-blue-primary'
                                                                onClick={handleSubmit}
                                                            >
                                                                Add More Parts
                                                            </button>
                                                        ) : (
                                                            <LoadingButtonFixedWidth />
                                                        )}
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
